import api from '../utils/api';


export const getAllDealers = (districtId) => {
    return api({
        url: '/api/districts/dealers/get-all-dealers/' + districtId,
        method: 'GET'
    })
}

export const getDealer = (districtId, manufacturerId) => {
    return api({
        url: '/api/districts/dealers/get-dealer/' + districtId + '/' + manufacturerId,
        method: 'GET'
    })
}

export const addDealer = (districtId, dealerId, manufacturerId) => {
    return api.post('api/districts/dealers/add-dealer/' + districtId + '/' + dealerId + '/' + manufacturerId);
}

export const getDealerDetails = (dealerIds) => {
    return api({
        url: '/api/districts/dealers/get-dealer-details/' + dealerIds,
        method: 'GET'
    })
}

export const removeDealer = (districtId, manufacturerId) => {
    return api.delete(`/api/districts/dealers/remove-dealer/${districtId}/${manufacturerId}`);
}
export const getDealersExceptDistrict = (districtId) => {
    return api({
        url: '/api/districts/dealers/get-dealers-except-district/' + districtId,
        method: 'GET'
    })
}

